/* eslint-disable @typescript-eslint/no-explicit-any */
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-premium';
import { baseCell } from 'components/cells';
import { filterOperators, dateFilterOperators } from 'components/enhanced';
import { useTranslation } from 'react-i18next';

export function DocumentColumns(
  handleDownload?: (row: any) => void,
  handleDelete?: (id: number) => void
): GridColDef[] {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t(`global.name`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'category',
      headerName: t(`pages.document.add.category`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'tipology',
      headerName: t(`pages.document.add.tipology`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'supplier',
      headerName: t(`global.supplier`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'warehouse',
      headerName: t(`global.warehouse`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      filterOperators,
      width: 400,
      renderCell: baseCell
    },

    {
      field: 'upload_date',
      headerName: t(`pages.document.upload_date`),
      filterOperators: dateFilterOperators,
      width: 200,
      renderCell: baseCell
    },

    {
      field: 'costum_actions',
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => {
        return [
          {
            label: t(`actions.download`),
            icon: <CloudDownloadIcon fontSize="small" />,
            onClick: () => handleDownload(params.row)
          }
        ];
      }
    } as GridColDef
  ];

  return columns;
}
